import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const PrintersListSkeleton = () => {
  return (
    <div className="pt-4" data-testid="printers-list-skeleton">
      <div className="mb-4">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <Skeleton className="h-8 w-full max-w-md rounded-full bg-hover-press sm:flex-1" />
          <Skeleton className="h-8 w-28 rounded-full bg-hover-press" />
        </div>
      </div>

      <div className="hidden md:block">
        <div className="overflow-hidden rounded-lg border border-card-border">
          <div className="grid grid-cols-12 gap-4 border-b border-card-border bg-card-bg p-4">
            <Skeleton className="col-span-3 h-4 w-24 rounded-full bg-hover-press" />
            <Skeleton className="col-span-2 h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="col-span-2 h-4 w-16 rounded-full bg-hover-press" />
            <Skeleton className="col-span-2 h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="col-span-2 h-4 w-16 rounded-full bg-hover-press" />
            <Skeleton className="col-span-1 h-4 w-8 rounded-full bg-hover-press" />
          </div>
          {[1, 2, 3].map((index) => (
            <div key={index} className="grid grid-cols-12 gap-4 border-b border-card-border p-4 last:border-b-0">
              <Skeleton className="col-span-3 h-4 w-32 rounded-full bg-hover-press" />
              <Skeleton className="col-span-2 h-4 w-24 rounded-full bg-hover-press" />
              <Skeleton className="col-span-2 h-4 w-16 rounded-full bg-hover-press" />
              <Skeleton className="col-span-2 h-4 w-20 rounded-full bg-hover-press" />
              <Skeleton className="col-span-2 h-4 w-16 rounded-full bg-hover-press" />
              <Skeleton className="col-span-1 h-4 w-8 rounded-full bg-hover-press" />
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-4 md:hidden">
        {[1, 2, 3].map((index) => (
          <SectionBox key={index} className="p-4">
            <div className="mb-3 flex items-center justify-between">
              <Skeleton className="h-5 w-32 rounded-full bg-hover-press" />
              <Skeleton className="h-6 w-16 rounded-full bg-hover-press" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
            </div>
          </SectionBox>
        ))}
      </div>
    </div>
  );
};
